import { render, staticRenderFns } from "./PermissionsTemplates.vue?vue&type=template&id=494fb338&"
import script from "./PermissionsTemplates.vue?vue&type=script&lang=js&"
export * from "./PermissionsTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports